
const Snackbar = ({ message, isActive }) => {
    // console.log("Snackbar: ", message);
    return (
        <div id="snackbar" className={isActive ? "show" : ""}>
            {message}
        </div>
    );
}

export default Snackbar;